<script lang="ts" module>
	import type { ClassValue, HTMLAttributes } from 'svelte/elements';
	import type { VariantProps } from 'tailwind-variants';
	import { tv } from '../tv';
	import { CROSS_SIZE_VARIANTS, MAIN_COLOR_VARIANTS } from '../variants';

	export const spinnerVariants = tv({
		base: 'inline-flex shrink-0 items-center justify-center',
		variants: {
			size: CROSS_SIZE_VARIANTS,
			variant: MAIN_COLOR_VARIANTS,
			fill: {
				Solid: '[--spinner-inner:var(--v-on-main)] [--spinner-outer:var(--v-main-line)]',
				Soft: '[--spinner-inner:var(--v-on-container)] [--spinner-outer:var(--v-container-line)]'
			}
		},
		defaultVariants: { size: '400', variant: 'Secondary', fill: 'Soft' }
	});

	export interface SpinnerProps
		extends Omit<HTMLAttributes<HTMLElement>, 'class'>, VariantProps<typeof spinnerVariants> {
		as?: string;
		class?: ClassValue;
		ref?: HTMLElement | null;
	}
</script>

<script lang="ts">
	let {
		as = 'span',
		class: className,
		fill,
		ref = $bindable(null),
		size,
		variant,
		...rest
	}: SpinnerProps = $props();
</script>

<svelte:element
	this={as}
	bind:this={ref}
	class={[spinnerVariants({ fill, size, variant }), className]}
	{...rest}
>
	<svg
		class="size-full animate-spin"
		viewBox="0 0 24 24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			class="fill-(--spinner-outer)"
			d="M5.98986 18.0104C7.52806 19.5486 9.65306 20.5 12.0003 20.5C16.6947 20.5 20.5003 16.6944 20.5003 12C20.5003 7.30558 16.6947 3.5 12.0003 3.5C9.65306 3.5 7.52806 4.45139 5.98986 5.98959L4.9292 4.92893C6.73884 3.11929 9.23884 2 12.0003 2C17.5231 2 22.0003 6.47715 22.0003 12C22.0003 17.5228 17.5231 22 12.0003 22C9.23884 22 6.73884 20.8807 4.9292 19.0711L5.98986 18.0104Z"
		/>
		<path
			class="fill-(--spinner-inner)"
			d="M4.92908 19.0711C3.1204 17.2624 2.00134 14.7641 2.00015 12.0044L2.00015 11.9956C2.00134 9.23593 3.1204 6.73763 4.92909 4.92896L5.98975 5.98962C4.45155 7.52781 3.50015 9.65281 3.50015 12C3.50015 14.3472 4.45155 16.4722 5.98975 18.0104L4.92908 19.0711Z"
		/>
	</svg>
</svelte:element>
